var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33925 1.75322C7.17128 1.37513 5.90159 1.90105 5.34305 2.9943L4.67156 4.3086C4.59178 4.46477 4.46477 4.59178 4.3086 4.67156L2.9943 5.34305C1.90105 5.90159 1.37513 7.17128 1.75322 8.33925L2.20777 9.74341C2.26178 9.91025 2.26178 10.0899 2.20777 10.2567L1.75322 11.6609C1.37513 12.8289 1.90105 14.0986 2.9943 14.6572L4.3086 15.3286C4.46477 15.4084 4.59178 15.5354 4.67156 15.6916L5.34305 17.0059C5.90159 18.0992 7.17128 18.6251 8.33925 18.247L9.74341 17.7924C9.91025 17.7384 10.0899 17.7384 10.2567 17.7924L11.6609 18.247C12.8289 18.6251 14.0986 18.0992 14.6572 17.0059L15.3286 15.6916C15.4084 15.5354 15.5354 15.4084 15.6916 15.3286L17.0059 14.6572C18.0992 14.0986 18.6251 12.8289 18.247 11.6609L17.7924 10.2567C17.7384 10.0899 17.7384 9.91025 17.7924 9.74341L18.247 8.33925C18.6251 7.17128 18.0992 5.90159 17.0059 5.34305L15.6916 4.67156C15.5354 4.59178 15.4084 4.46477 15.3286 4.3086L14.6572 2.9943C14.0986 1.90105 12.8289 1.37513 11.6609 1.75322L10.2567 2.20777C10.0899 2.26177 9.91025 2.26178 9.74341 2.20777L8.33925 1.75322ZM5.63322 9.79783L6.81174 8.61925L9.16875 10.9763L13.8828 6.26229L15.0613 7.4408L9.16875 13.3333L5.63322 9.79783Z",
    fill: "#1A8C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.ff1ba1a03fdbc19591314be2bc077939.svg";
export { ForwardRef as ReactComponent };